import { useCallback } from 'react';
import { getToken } from 'firebase/messaging';
import { getFirebaseMessaging } from '@/firebase/config';
import { postFcmDeviceToken } from '@/api/fcm/postFcmDeviceToken';
import { useAppDispatch } from '@/stores/hooks';
import { fcm } from '@/stores/slices/notification/fcmSlice';

export const useFcmToken = () => {
  const dispatch = useAppDispatch();
  const requestFcmToken = useCallback(async () => {
    try {
      // 브라우저 알림을 지원하는지 확인
      if (!('Notification' in window)) {
        console.log('이 브라우저는 알림을 지원하지 않습니다.');
        return null;
      }

      // 권한 요청
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.log('알림 권한이 거부되었습니다.');
        return null;
      }

      // messaging 인스턴스 가져오기
      const messaging = await getFirebaseMessaging();
      if (!messaging) {
        console.log('이 브라우저는 FCM을 지원하지 않습니다.');
        return null;
      }

      // 서비스 워커 등록 확인
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js'
      );

      // 토큰 발급
      const token = await getToken(messaging, {
        vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: registration,
      });
      if (!token) {
        console.log('토큰을 발급받지 못했습니다.');
        return null;
      }

      dispatch(fcm.setFcmToken(token));

      // 서버에 토큰 등록
      const res = await postFcmDeviceToken({ token, platform: 'web' });
      if (!res.isSuccess) {
        if (res.error.code === 'E_NOTIFICATION_001') {
          console.log('이미 등록된 디바이스 토큰입니다.'); // 이미 등록되어 있을 경우 처리 x
        } else if (res.error.code === 'E_NOTIFICATION_003') {
          console.error('유효하지 않은 플랫폼 값:', res.error.message);
        } else {
          console.error('FCM 토큰 등록 실패:', res.error);
        }
        return null;
      }

      return token;
    } catch (error) {
      console.error('FCM 토큰 발급 실패:', error);
      return null;
    }
  }, [dispatch]);

  return { requestFcmToken };
};
